// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"jo-z","imageAndVideoCount":"ko-z","imageAndVideoContainer":"lo-z","viewAllReviews":"mo-z"};